package uz.ferro.erp.feature.text.model

import kotlinx.serialization.Serializable

@Serializable
data class DocContent(
    val items: List<DocItem>?,
    val style: TextStyle?,
    val text: String?
)